import { Fade } from "react-reveal";
import "./style.css";
import news_bg from "../../assets/images/teambg.jpg";
import NewsCard from "../../components/Card/NewsCard";

const News = () => {
  return (
    <main className="news">
      <div
        className="img_content"
        style={{
          "--background": `url(${news_bg})`,
        }}
      >
        <div className="overlay"></div>
        <Fade top duration={1000}>
          <h2 className="text_primary">OUR NEWS</h2>
        </Fade>
      </div>
      <section className="cs_container">
        <div className="news_card_row">
          {[...new Array(1)].map((v, i) => (
            <div key={i} className="news_col">
              <NewsCard
                url="/news-blog"
                data={{
                  img: "https://cdn.pixabay.com/photo/2018/04/05/23/59/nature-3294632_1280.jpg",
                  title: "29 September 2022",
                  desc: "Crypteco first news",
                }}
              />
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default News;
